// Third-party imports.
import React from "react";
import PropTypes from "prop-types";

class ButtonWithSpinner extends React.Component {
  static propTypes = {
    // Text on the button.
    text: PropTypes.string.isRequired,
    dataAnalyticsId: PropTypes.string,

    // Optional: This is used if you want to explicitly pass a function to call.
    // This is not necessary if you are using this is as a button to a form.
    onClick: PropTypes.func,

    // When this is true, hide the text and display the spinning animation. When it is false,
    // display the text and hide the animation.
    isSpinning: PropTypes.bool.isRequired,

    // Optional. If true, disable clicking on the button.
    isDisabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // TODO: Make sure this is not breaking anything
    let inputElement = null;

    if (this.props.onClick !== null) {
      inputElement = (
        <input
          type="submit"
          data-analytics-id={this.props.dataAnalyticsId}
          className={`primary-button ${this.props.isSpinning ? "spin-hidden-text" : ""}`}
          value={this.props.text}
          disabled={this.props.isDisabled}
          onClick={this.props.onClick}
          style={{ width: `${this.widthInRems}rem` }}
        />
      );
    } else {
      inputElement = (
        <input
          type="submit"
          data-analytics-id={this.props.dataAnalyticsId}
          className={`primary-button ${this.props.isSpinning ? "spin-hidden-text" : ""}`}
          value={this.props.text}
          disabled={this.props.isDisabled}
          style={{ width: `${this.widthInRems}rem` }}
        />
      );
    }

    const spinElement = this.props.isSpinning ? <div className="spin-element" /> : null;

    return (
      <div className="button-with-spinner">
        {inputElement}

        <div className="spin-container">{spinElement}</div>
      </div>
    );
  }
}

export default ButtonWithSpinner;
